import { useCallback } from "react";
import { Control, Path } from "react-hook-form";

import ClearIcon from "@mui/icons-material/Clear";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { AppointmentFormValues } from "features/scheduling/appointment-form/appointment-form.component";
import useShowPickers from "features/scheduling/appointment-form/use-show-pickers.hook";

import AppointmentDateField from "./appointment-date-field";

type AppointmentDateFieldProps = {
  label: string;
  name: Path<AppointmentFormValues>;
  control: Control<AppointmentFormValues, object>;
  setValue: (
    name: Path<AppointmentFormValues>,
    value: any,
    options?: any
  ) => void;
  required?: boolean;
  maxDate?: Date;
};

export default function AppointmentOptionalDateField({
  label,
  control,
  name,
  setValue,
  required,
  maxDate
}: AppointmentDateFieldProps) {
  const { setOpenEndDate } = useShowPickers();

  const closeAllPickers = useCallback(() => {
    setOpenEndDate(false);
  }, [setOpenEndDate]);

  const clearPicker = useCallback(() => {
    setValue("event_end_date", null, { shouldValidate: true });
    closeAllPickers();
  }, [setValue, closeAllPickers]);

  return (
    <ClickAwayListener onClickAway={closeAllPickers}>
      <Stack direction="row" spacing={2} pl="36px" alignItems="center">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <AppointmentDateField
            name={name}
            control={control}
            hidePicker={closeAllPickers}
            label={label}
            required={Boolean(required)}
            maxDate={maxDate}
          />
        </LocalizationProvider>
        <IconButton
          size="small"
          sx={{
            transform: "translate(-15px, 0px)"
          }}
          onClick={clearPicker}
        >
          <ClearIcon sx={{ width: 18, height: 18 }} />
        </IconButton>
      </Stack>
    </ClickAwayListener>
  );
}
